
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { ConfigureServiceProvider } from '../configure-service/configure-service';


// let summary_api='http://192.168.65.212:82/EPC_V3.svc/summary/';
// // let postadd_api='http://192.168.65.212:82/EPC_V3.sv/postadd/';
// let login_api='http://192.168.65.212:82/EPC_V3.svc/login/';
// let fieldApi = 'http://192.168.65.212:82/EPC_V3.svc/GetFieldProperties/';
@Injectable()
export class DeskPageServiceProvider {
  host: string;
  summaryApi: string;
  postaddApi: string;
  fieldApi: string;
  loginApi: string;
  lookupTriggerApi: string;
  // pages: any = [];
  // icons: any = {};
  // panels: any = {};
  // currentPage: string = '0';
  // lastOpenPanelForPage: any = {};
  // cpTitle: string = "Home";
  // iconArr: any = [];
  // panelArr: any = [];
  // def_icon = "assets/apps_icon_def.png";
  // parentWindow: HTMLElement;
  // pageTitlechange = null;
  // iconsindesk: any = {};
  // childWindows = {};
  constructor(public http: Http, public configureService: ConfigureServiceProvider) {
    console.log('Hello DeskPageServiceProvider Provider');
    this.host = this.configureService.getHost();
    this.summaryApi = this.host + 'summary/';
    this.postaddApi = this.host + 'postadd/';
    this.fieldApi = this.host + 'GetFieldProperties/';
    this.loginApi = this.host + 'login/';
    this.lookupTriggerApi = this.host + 'LoopupList/';
  }
  formatpostdata(json): string {
    let obj = { data: JSON.stringify(json) };
    let pdata = JSON.stringify(obj);
    return pdata;
  }
  postData(data) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this.http.post(this.summaryApi, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {

          resolve(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }
  fieldPropertyData(data) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this.http.post(this.fieldApi, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {

          resolve(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }

  logindata(data) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this.http.post(this.loginApi, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {

          resolve(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }

  postAddAPI(data) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this.http.post(this.postaddApi, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {

          resolve(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }

  LookupList(data) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this.http.post(this.lookupTriggerApi, this.formatpostdata(data), options)
        .map(res => res.json())
        .subscribe(data => {

          resolve(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/desk-page-service/desk-page-service.ts